import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offline-ccm',
  templateUrl: './offline-ccm.component.html',
  styleUrls: ['./offline-ccm.component.scss']
})
export class OfflineCcmComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    // console.log("test")
  }

}
